import { render } from "./S3Galeria.vue?vue&type=template&id=1cecd51e&scoped=true"
import script from "./S3Galeria.vue?vue&type=script&lang=js"
export * from "./S3Galeria.vue?vue&type=script&lang=js"

import "./S3Galeria.vue?vue&type=style&index=0&id=1cecd51e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cecd51e"]])

export default __exports__